import Veraportal from "./Veraportal";
import {IPortalseite} from "./Interfaces";
import Utilities from "./Utilities";

export default class LieferadresseAnpassen extends Veraportal implements IPortalseite {
    override async onSeiteLoad(): Promise<boolean> {
        //region Eingabebeschränkungen Lieferadressformular
        $(`#lieferadresse-aendern-schulname`).on('keyup', (evt) => {
            Utilities.forceKeys($(evt.target)[0] as HTMLInputElement, 'A-Za-z0-9äÄüÜöÖß\\-\\ \\.\\(\\)', false, true);
        });
        $(`#lieferadresse-aendern-strasse`).on('keyup', (evt) => {
            Utilities.forceKeys($(evt.target)[0] as HTMLInputElement, 'A-Za-z0-9äÄüÜöÖß\\-\\ \\.', false, true);
        });
        $(`#lieferadresse-aendern-plz`).on('keyup', (evt) => {
            Utilities.forceKeys($(evt.target)[0] as HTMLInputElement, '0-9', false, false);
        });
        $(`#lieferadresse-aendern-ort`).on('keyup', (evt) => {
            Utilities.forceKeys($(evt.target)[0] as HTMLInputElement, 'A-Za-z0-9äÄüÜöÖß\\-\\ \\.\\(\\)', false, true);
        });
        $(`#lieferadresse-aendern-telefon`).on('keyup', (evt) => {
            Utilities.forceKeys($(evt.target)[0] as HTMLInputElement, '0-9', false, false);
        });
        $(`#lieferadresse-aendern-email`).on('keyup', (evt) => {
            Utilities.forceKeys($(evt.target)[0] as HTMLInputElement, 'A-Za-z0-9äÄüÜöÖß\\-\\@\\_\\.', false, false);
        });
        //endregion


        return true;
    }

    override async onSeiteFinished(): Promise<boolean> {
        return true;
    }

    override async onSeiteLeave(): Promise<boolean> {
        return true;
    }
}